import { NavLink } from 'react-router-dom';
import type { ComponentType, SVGProps } from 'react';
import {
  IconeMeuTrabalho,
  IconeIntake,
  IconeProjetos,
  IconeProgramas,
  IconePortfolio,
  IconeScorecards,
  IconeWorkload,
  IconeRaid,
  IconeBlueprints,
} from './icones-navegacao.js';

type ComponenteIcone = ComponentType<SVGProps<SVGSVGElement>>;

interface ItemNavegacao {
  rota: string;
  label: string;
  Icone: ComponenteIcone;
}

// SPEC-UX-COMPASSO.md §2.2 — árvore de navegação exata. Dashboard,
// Relatórios, Timesheet, Calendário, Kanban, Aprovações e Busca dedicada
// NÃO são itens de menu (§2.2: "deixam de ser lugares"). Ícones e largura
// reforçados em §2.4 — estrutura, não paleta.
export const GRUPOS: { titulo: string | null; itens: ItemNavegacao[] }[] = [
  { titulo: null, itens: [{ rota: '/meu-trabalho', label: 'Meu Trabalho', Icone: IconeMeuTrabalho }] },
  {
    titulo: 'Fluxo',
    itens: [
      { rota: '/intake', label: 'Intake', Icone: IconeIntake },
      { rota: '/projetos', label: 'Projetos', Icone: IconeProjetos },
      { rota: '/programas', label: 'Programas', Icone: IconeProgramas },
      { rota: '/portfolio', label: 'Portfólio', Icone: IconePortfolio },
      { rota: '/scorecards', label: 'Scorecards', Icone: IconeScorecards },
    ],
  },
  {
    titulo: 'Apoio',
    itens: [
      { rota: '/workload', label: 'Workload', Icone: IconeWorkload },
      { rota: '/raid', label: 'RAID', Icone: IconeRaid },
      { rota: '/blueprints', label: 'Blueprints', Icone: IconeBlueprints },
    ],
  },
];

function itemClasse(ativo: boolean): string {
  return `flex items-center gap-2.5 rounded px-3 py-2 text-sm transition-colors ${
    ativo ? 'bg-aco/10 font-medium text-aco-700' : 'text-ink hover:bg-borda/50'
  }`;
}

function iconeClasse(ativo: boolean): string {
  return `shrink-0 ${ativo ? 'text-aco-700' : 'text-grafite'}`;
}

export function Navegacao() {
  return (
    <nav className="flex h-full w-[248px] flex-col gap-5 border-r border-borda bg-superficie p-4" aria-label="Navegação principal">
      <div className="flex flex-col gap-0.5 px-3">
        <span className="text-[15px] font-bold tracking-wide text-ink">COMPASSO</span>
        <span className="text-[11px] font-semibold uppercase tracking-wide text-grafite">PPM · Erzinger</span>
      </div>
      {GRUPOS.map((grupo, i) => (
        <div key={grupo.titulo ?? i}>
          {grupo.titulo && <div className="px-3 pb-1 text-xs font-semibold uppercase tracking-wide text-grafite">{grupo.titulo}</div>}
          <ul className="flex flex-col gap-0.5">
            {grupo.itens.map((item) => (
              <li key={item.rota}>
                <NavLink to={item.rota} className={({ isActive }) => itemClasse(isActive)}>
                  {({ isActive }) => (
                    <>
                      <item.Icone className={iconeClasse(isActive)} />
                      {item.label}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
